import fse from 'fs-extra';
import { Common, ResolveState } from '../../common';
import { CodeFilePaths } from '../get-files';
import { ErrorResult } from '../models/error-result';
import { Updater } from '../models/updater-interface';

export class ComponentSelectorUpdater implements Updater {
    /**
     * Resolves component-selector linter error
     * @param {string} fileData String contents of file containing linter error
     * @param {ErrorResult} error Object representing linter error
     * @returns {Promise<string>} Updated file content after resolving linter error or the original contents if unable to resolve
     */
    public async update(fileData: string, error: ErrorResult): Promise<string> {
        const selectorNameRegex = /(?<=selector:\s*').+(?=')/;
        const selectorName = fileData.match(selectorNameRegex);

        if (selectorName === null) {
            return fileData;
        }

        const newSelectorName = 'sme-' + selectorName;
        const result = Common.replaceInString(fileData, selectorNameRegex, newSelectorName);

        const files = await CodeFilePaths.initialize();

        for (const file of files) {
            this.findAndReplaceInFile(file, selectorName[0], newSelectorName);
        }

        error.resolved = ResolveState.Resolved;
        return new Promise(resolve => resolve(result));
    }

    private findAndReplaceInFile(filePath: string, selectorName: string, newSelectorName: string): void {
        let fileData = Common.readFileData(filePath);

        if (!fileData) {
            return;
        }

        const selectorUsageRegex = new RegExp(`(?<=(?<!selector:\\s*)'|<|<\\/)${selectorName}`, 'g');
        if (fileData.match(selectorUsageRegex) === null) {
            return;
        }

        fileData = Common.replaceInString(fileData, selectorUsageRegex, newSelectorName);

        fse.writeFileSync(filePath, fileData);
    }
}
